import StandardTabPanel from "../../../ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ viewName, id, activeTab, tabs = [], children }) {
  const allTabs = tabs.map((tab) => ({
    key: tab.key,
    name: tab.name,
    isDisabled: false,
    permission: null,
    href:
      tab.subtabs?.length > 0
        ? `/${viewName}/${id}/${tab.key}/${tab.subtabs[0].key}`
        : `/${viewName}/${id}/${tab.key}`,
  }));

  return (
    <div className="bg-white relative flex h-full flex-1 flex-col items-stretch rounded-[15px] shadow-[3px_3px_10px_0px_rgb(188,209,255)]">
      <StandardTabPanel
        activeTab={activeTab}
        tabList={allTabs}
        headerTabSx={TAB_STYLES.TAB.SX}
        headerTabIndicatorSx={TAB_STYLES.TAB.TAB_INDICATOR_SX}
      >
        {children}
      </StandardTabPanel>
    </div>
  );
}
